import { j as i } from "./jsx-runtime-B6kdoens.js";
import { useMemo as n } from "react";
import { f as x } from "./create-component-CBAeEoQ6.js";
const j = (o, m, r) => {
  const s = x(
    (t, p) => {
      const e = n(() => r == null ? void 0 : r(), []);
      return /* @__PURE__ */ i.jsx(m.Provider, { value: e, children: /* @__PURE__ */ i.jsx(o, { ...t, ref: p }) });
    }
  );
  return s.displayName = `withProvider(${o.displayName})`, s;
};
export {
  j as w
};
//# sourceMappingURL=atom-provider-B3P183Tj.js.map
